// angular
//   .module("HeroPRO")
//   .controller("ProductDetailController",

import './productDetail.scss';

/* @ngInject */
export default function ProductDetailController($scope, $rootScope, $stateParams, $location, $window, productLookupService, categoryCacheService, geoStateCacheService, HPGeoStates, HPConfig, raSpinnerService) {
    const vm = this;
    vm.mfaForm = {};


    vm.productDetail = [];
    vm.productCode = ($stateParams.Id).split('_');
    vm.productTypeID = parseInt(vm.productCode[0]);
    vm.productID = parseInt(vm.productCode[1]) || null;
    vm.productGeoState = $stateParams.GeoState;
    vm.type = null;
    vm.MFAResultLow = null;
    vm.MFAResultMean = null;
    vm.MFAResultMax = null;
    vm.formCheckBoxesValid = true;
    vm.calculatedOnce = false;
    vm.showMFACalc = HPConfig.showMFACalc && $location.search().showMFACalc;

    $scope.$on('productCenter.setupComplete', () => {
        vm.currentGeoStateObject = geoStateCacheService.getCurrentStateObject();
        // find the type
        vm.type = angular.copy(categoryCacheService.getProductTypeByProductTypeId(vm.productTypeID));
        getProductDetail();
    });


    // Get product detail
    var getProductDetail = function () {
        const promise = productLookupService.getProductInfo(vm.productTypeID, vm.productID);
        promise.then((response) => {
            vm.productDetail = response.data;
            if (raSpinnerService.isRegistered('productDetailSpinner')) {
                raSpinnerService.hide('productDetailSpinner');
            }
            if (vm.type.NoProducts) {
                $rootScope.$broadcast('productDetailController.isNoProductProduct');
            }
        }, (reason) => {
            $window.alert(`Failed: ${reason}`);
        });
    };

    $scope.$on('inputTypesDirective.MFAFormChanged', () => {
        vm.MFAResultLow = null;
        vm.MFAResultMean = null;
        vm.MFAResultMax = null;
    });

    $scope.$on('inputTypesDirective.checkBoxValidation', () => {
        validateCheckboxes();
    });


    vm.calculateMFA = function () {
        const productDetails = [];

        // build product details - could go somewhere else, or a function?
        for (let i = 0; i < vm.productDetail.InputsForMFA.length; i++) {
            const inputForMFA = vm.productDetail.InputsForMFA[i];

            const inputName = `${inputForMFA.TypeId}-${inputForMFA.Deprecated_ProductAttributeNameId}`;

            switch (inputForMFA.TypeId) {
            case 1: // textbox
                productDetails.push({
                    productAttributeId: inputForMFA.Deprecated_ProductAttributeNameId,
                    productOptionIds: [],
                    Val: vm.mfaForm[inputName],
                });
                break;
            case 2: // checkbox
            case 5:

                var options = [];

                for (const key in vm.mfaForm[inputName]) {
                    if (vm.mfaForm[inputName][key] === true) {
                        options.push(key);
                    }
                }

                productDetails.push({
                    productAttributeId: inputForMFA.Deprecated_ProductAttributeNameId,
                    productOptionIds: options,
                });

                break;
            case 3: // radio
                productDetails.push({
                    productAttributeId: inputForMFA.Deprecated_ProductAttributeNameId,
                    productOptionIds: [vm.mfaForm[inputName].$viewValue],
                });
                break;
            case 4: // dropdown
                productDetails.push({
                    productAttributeId: inputForMFA.Deprecated_ProductAttributeNameId,
                    productOptionIds: [vm.mfaForm[inputName].InputOptionId],
                });

                break;
            }
        }


        const promise = productLookupService.getMFACalculation({
            StateId: geoStateCacheService.getCurrentStateObject().StateGeoId,
            CalculatorArgs: {
                ProductId: vm.productID,
                ProductDetails: productDetails,
            },
        });
        promise.then((response) => {
            vm.MFAResultLow = response.data.FMPCCalculatorResult.PredictedPriceDeviation;
            vm.MFAResultMean = response.data.FMPCCalculatorResult.PredictedMeanPrice;
            vm.MFAResultMax = response.data.MaximumFinancingAmount;
            vm.calculatedOnce = true;
            // vm.productDetail = response.data;
        }, (reason) => {
            $window.alert(`Failed: ${reason}`);
        });
    };

    $scope.$on('inputTypesDirective.filtersLoaded', () => {
        // Loop through mfaForm values, check if its a checkbox and if so, if it's valid
        validateCheckboxes();
    });

    function validateCheckboxes() {
        vm.formCheckBoxesValid = true;
        for (const input in vm.mfaForm) {
            if (input.charAt(0) === '2' && vm.mfaForm[input].checkboxInvalid) {
                vm.formCheckBoxesValid = false;
                break;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/productCenter/pages/productdetail/productDetailController.js